import React, { Component } from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import money, { format } from '../../lib/money';
import TermsAndConditionsLink from '../../containers/terms-and-conditions-link';
import { formatMessage } from '../../lib/intl';

const i18n = defineMessages({
  noExtraFees: {
    id: 'id.purchaseFeesDisclaimer.noExtraFees',
    defaultMessage: 'No extra fees to split the cost.',
  },
  freeForYou: {
    id: 'id.purchaseFeesDisclaimer.freeForYou',
    defaultMessage: 'free for you; ',
  },
  forOthersToJoin: {
    id: 'id.purchaseFeesDisclaimer.forOthersToJoin',
    defaultMessage: 'for others to join',
  },
  txnFeePerShare: {
    id: 'id.purchaseFeesDisclaimer.txnFeePerShare',
    defaultMessage: 'Transaction fee: {prefix} {perShare}/share {suffix}. No hidden fees.',
  },
  txnFeePercentMinAndMax: {
    id: 'id.purchaseFeesDisclaimer.txnFeePercentMinAndMax',
    defaultMessage: 'Transaction fee: {prefix} {percent}% (min: {min} & cap: {max}) {suffix}. No hidden fees.',
  },
  txnFeePercentAndMin: {
    id: 'id.purchaseFeesDisclaimer.txnFeePercentAndMin',
    defaultMessage: 'Transaction fee: {prefix} {percent}% (min: {min}) {suffix}. No hidden fees.',
  },
  txnFeePercentAndMax: {
    id: 'id.purchaseFeesDisclaimer.txnFeePercentAndMax',
    defaultMessage: 'Transaction fee: {prefix} {percent}% (cap: {max}) {suffix}. No hidden fees.',
  },
  txnFeePercent: {
    id: 'id.purchaseFeesDisclaimer.txnFeePercent',
    defaultMessage: 'Transaction fee: {prefix} {percent}% {suffix}. No hidden fees.',
  },
})

export class PurchaseFeesDisclaimer extends Component {
  constructor(props) {
    super(props);

    this.formatMessage = formatMessage(this.props.intl);
  }

  get fees() { return this.props.fees; }

  get perShareMax() { return money(this.fees.perShareMax); }

  get perShareMin() { return money(this.fees.perShareMin); }

  get feePercentage() { return this.fees.percentage; }

  purchaseHasFees() {
    const { fees: { perShare, percentage } } = this.props;
    return (perShare && perShare.isPositive()) || (percentage && percentage > 0);
  }

  bestFeesShareText() {
    const { fees: { perShare } } = this.props;

    if (!this.purchaseHasFees()) return this.formatMessage(i18n.noExtraFees);
    if (perShare && perShare.isPositive()) return this.perShareFeesText();

    return this.percentageFeesText();
  }

  perShareFeesText() {
    const { fees } = this.props;
    const specialCases = !this.props.applyConsumerFeeToOrganizer;
    const prefix = specialCases ? this.formatMessage(i18n.freeForYou) : '';
    const suffix = specialCases ? this.formatMessage(i18n.forOthersToJoin) : '';

    return this.formatMessage(i18n.txnFeePerShare, {
      prefix,
      suffix,
      perShare: format(fees.perShare),
    });
  }

  percentageFeesText() {
    const { fees } = this.props;
    const percent = fees.percentage;
    const min = format(this.perShareMin);
    const max = format(this.perShareMax);

    const specialCases = !this.props.applyConsumerFeeToOrganizer;
    const prefix = specialCases ? this.formatMessage(i18n.freeForYou) : '';
    const suffix = specialCases ? this.formatMessage(i18n.forOthersToJoin) : '';

    if (percent && min && max) {
      return this.formatMessage(i18n.txnFeePercentMinAndMax, {
        prefix,
        percent,
        min,
        max,
        suffix,
      });
    }

    if (percent && min) {
      return this.formatMessage(i18n.txnFeePercentAndMin, {
        prefix,
        percent,
        min,
        suffix,
      });
    }

    if (percent && max) {
      return this.formatMessage(i18n.txnFeePercentAndMax, {
        prefix,
        percent,
        max,
        suffix,
      });
    }

    if (percent && !min && !max) {
      return this.formatMessage(i18n.txnFeePercent, {
        prefix,
        percent,
        suffix,
      });
    }

    return this.formatMessage(i18n.noExtraFees);
  }

  render() {
    return (
      <p className="purchase-fees-disclaimer small-print">
        {this.bestFeesShareText()}
        {' '}
        <TermsAndConditionsLink />
      </p>
    );
  }
}

export default injectIntl(PurchaseFeesDisclaimer);



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-claim/purchase-fees-disclaimer.js